import { api } from "../config/api";

export const getGoldPlanPrices = async () => {
  const response = await api.get("/subscriptions/gold-plans");
  return response.data; // { oneMonth, threeMonths, sixMonths, oneYear }
};

export const getMySubscription = async () => {
  const response = await api.get("/subscriptions/me");
  return response.data; // { hasActivePlan, plan, planValue, endDate } ou { hasActivePlan: false }
};